import { render, staticRenderFns } from "./TimetableSplitViewHandleBar.vue?vue&type=template&id=68174542"
import script from "./TimetableSplitViewHandleBar.vue?vue&type=script&lang=js"
export * from "./TimetableSplitViewHandleBar.vue?vue&type=script&lang=js"
import style0 from "./TimetableSplitViewHandleBar.vue?vue&type=style&index=0&id=68174542&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports